// extracted by mini-css-extract-plugin
export default {"tabContent":"PropertyListV2__tabContent___1I-Rz"};